import { render, staticRenderFns } from "./fundList.vue?vue&type=template&id=275c17b4"
import script from "./fundList.vue?vue&type=script&lang=js"
export * from "./fundList.vue?vue&type=script&lang=js"
import style0 from "./fundList.vue?vue&type=style&index=0&id=275c17b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports